import {Component, EventEmitter, forwardRef, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {DomHandler} from 'primeng/primeng';

export const INPUT_TEXT_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => InputFileComponent),
  multi: true,
};

@Component({
  selector: 'cat-input-file',
  templateUrl: './input-file.component.html',
  styleUrls: ['./input-file.component.scss'],
  providers: [INPUT_TEXT_VALUE_ACCESSOR, DomHandler],

})
export class InputFileComponent implements ControlValueAccessor {

  @Output() change = new EventEmitter<FileList>();

  dragActive = false;

  onFileDrop(files: FileList) {
    this.dragActive = false;
    this.change.emit(files);
  }

  onDragEnter() {
    this.dragActive = true;
  }

  onDragLeave() {
    this.dragActive = false;
  }

  writeValue(obj: any): void {
  }

  registerOnChange(fn: any): void {
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState(isDisabled: boolean): void {
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/ui-form/components/input-file/input-file.component.ts